module.exports = __webpack_public_path__ + "img/ext7.568247f4.png";